import { useEffect, useState } from 'react';
import api from '../api/axios';

export default function usePublicPlans() {
  const [state, setState] = useState({ plans: [], loading: true, error: false });

  useEffect(() => {
    let active = true;
    api.get('/subscription/public-plans/')
      .then(res => active && setState({ plans: Array.isArray(res.data) ? res.data : [], loading: false, error: false }))
      .catch(() => active && setState({ plans: [], loading: false, error: true }));
    return () => { active = false; };
  }, []);

  return state;
}
